/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const SUPER_ADMIN_CAN_ABILITY = [
  //Route Access
  ["read", "MyProfile"],
  ["read", "DashboardOverview"],
  ["read", "DashboardIssuerAnalysis"],
  ["read", "PrebookToActualBoxes"],
  ["read", "Masquerader"],
  ["read", "UserList"],
  ["read", "SectionOptionType"],
  ["read", "InventoryTemplate"],
  ["read", "DiscountCouponList"],
  ["read", "CommDisList"],
  ["read", "MasqInvitationWithDiscountTemplate"],
  ["read", "CybersourcePayment"],
  ["read", "Committe"],
  ["read", "SectionOptionTypeInventory"],
  ["read", "CreateSOTInventory"],
  ["read", "PresentationAccordian"],
  ["read", "LocalAssetsImport"],
  ["read", "GlobalAssetsImport"],
  ["read", "SectionAssetsImport"],
  ["read", "SalesStatReport"],
  ["read", "Presentation"],
  ["read", "InventoryView"],
  ["read", "GenerateDiscount"],
  ["read", "DiscountList"],
  ["read", "InviteCommitteMember"],
  ["read", "Invite"],
  ["read", "PaymentFailedFAC"],
  ["read", "InviteMasqueraderPurchase"],
  ["read", "MasqueraderList"],
  ["read", "CommitteList"],
  ["read", "UpdatedBox"],
  ["read", "DeletedBox"],
  ["read", "DeletedViewBox"],
  ["read", "PresentationList"],
  ["read", "PresentationInventory"],
  ["read", "OrgProfile"],
  ["read", "SectionOptionInventory"],
  ["read", "InventoryControl"],
  ["read", "MasqueraderReport"],
  ["read", "PurchasedCostume"],
  ["read", "ViewBoxDetails"],
  ["read", "ViewMasqBoxDetails"],
  ["read", "ChangeCostumeOptions"],
  ["read", "MasqViewBox"],
  ["read", "MasqBoxList"],
  ["read", "SwitchSection"],
  ["read", "SectionBasePriceSummary"],
  ["read", "InventorySummary"],
  ["read", "InventorySummaryDetail"],
  ["read", "InventoryDetailView"],
  // ["read", "CommitteReport"],
  ["read", "PaymentStatsReport"],
  ["read", "CommitteMemberReport"],
  ["read", "DiscountInvite"],
  ["read", "CreateMasqBox"],
  ["read", "ZeroPaymentReport"],
  ["read", "PartialPaymentReport"],
  ["read", "FullPaymentReport"],
  ["read", "DiscountReport"],
  ["read", "SalesReport"],
  ["read", "OpenRegisterFlair"],
  ["read", "OpenRegisterElektra"],
  ["read", "OpenRegisterScorch"],
  ["read", "OpenRegisterTravisWorld"],
  ["read", "OpenRegisterEpicCarnival"],
  ["read", "OpenRegisterBattalionMusic"],
  ["read", "OpenRegisterGenx"],
  ["read", "OpenRegisterTriniJungleJuice"],
  ["read", "OpenRegisterIslandCrashers"],
  ["read", "OpenRegisterLil"],
  ["read", "OpenRegisterSolangeGovia"],
  ["read", "OpenRegisterAbsolute"],
  ["read", "OpenRegisterEnergy"],
  ["read", "OpenRegisterHouseOfBachannal"],
  ["read", "OpenRegisterDLux"],
  ["read", "OpenRegisterPunchyPunch"],
  ["read", "OpenRegisterLauraNa"],
  ["read", "OpenRegisterChandraMaharaj"],
  ["read", "OpenRegisterShawnDhanraj"],
  ["read", "OpenRegisterMADJouvert"],
  ["read", "OpenRegisterBikiniCabana"],
  ["read", "OpenRegisterFarmhouse"],
  ["read", "OpenRegisterJCAMFitness"],
  ["read", "OpenRegisterIImagine"],
  ["read", "OpenRegisterKRISP"],
  ["read", "OpenRegisterKristenCamacho"],
  ["read", "OpenRegisterLiveInLove"],
  ["read", "OpenRegisterMarkCorreia"],
  ["read", "OpenRegisterMixedNutz"],
  ["read", "OpenRegisterRoyale"],
  ["read", "OpenRegisterWinerboy"],
  ["read", "OpenRegisterMVP"],
  ["read", "OpenRegisterNatalieFonrose"],
  ["read", "OpenRegisterDavidDewer"],
  ["read", "OpenRegisterTribeU"],
  ["read", "OpenRegisterClubhouse"],
  ["read", "OpenRegisterMidnight"],
  ["read", "OpenRegisterMarieange"],
  ["read", "OpenRegisterLivinLocal"],
  ["read", "OpenRegisterDean"],
  ["read", "OpenRegisterMonique"],
  ["read", "OpenRegisterGerard"],
  ["read", "OpenRegisterMelissa"],
  ["read", "OpenRegisterLana"],
  ["read", "OpenRegisterGail"],
  ["read", "OpenRegisterDwayne"],
  ["read", "OpenRegister"],
  ["read", "PaymentTransaction"],
  ["read", "ManageOpenRegistration"],
  ["read", "FHPolicy"],
  ["read", "ProfileUpdateStepper"],
  ["read", "AboutMe"],
  ["read", "CostumeInventoryReport"],
  ["read", "SectionOptInvReport"],
  ["read", "CostumeMatrixSummary"],
  ["read", "PaymentReport"],
  ["read", "DeliveredReport"],
  ["read", "InviteesList"],
  ["read", "PrintLabels"],
  ["read", "ScheduleTable"],
  ["read", "BlackListUsers"],
  ["read", "BlockListUsers"],
  ["read", "ShelfList"],
  ["read", "ScheduleList"],
  ["read", "ShelfDetail"],
  ["read", "BoxDetail"],
  ["read", "OTPTemplate"],
  ["read", "MasqInvitationTemplate"],
  ["read", "DiscountCodeTemplate"],
  ["read", "CommitteeInvitationTemplate"],
  ["read", "MasqDownPaymentTemplate"],
  ["read", "DeletedBoxTemplate"],
  ["read", "AdminInvitationTemplate"],
  ["read", "DiscountInviteTemplate"],
  ["read", "CashierInviteTemplate"],
  ["read", "CostumePurchaseInviteTemplate"],
  ["read", "InvoiceTemplate"],
  ["read", "TransferBoxNewUserTemplate"],
  ["read", "TransferBoxOldUserTemplate"],
  ["read", "CommonEmailVerificationTemplate"],
  ["read", "Settings"],
  ["read", "BandRouteLiveMap"],
  ["read", "BandRouteMap"],
  ["read", "ButtonSettings"],
  ["read", "TermsAndConditions"],
  ["read", "CreateDiscount"],
  ["read", "ThemeAndLogo"],
  ["read", "PreBookInviteTemplate"],
  ["read", "PreBookDownPaymentEmailTemplate"],
  ["read", "PartialRemainderEmailTemplate"],
  ["read", "UnPaidRemainderEmailTemplate"],
  ["read", "CouponReport"],
  ["read", "CashSupervisorInvitationTemplate"],
  ["read", "SupervisorInvitationTemplate"],
  ["read", "APV2PaymentDetails"],
];

export const SUPER_ADMIN_CANNOT_ABILITY = [
  //Route Access Denial
  //  ["read", "Button"],
  ["read", "Costume"],
  ["read", "CostumeOpenReg"],
  ["read", "OpenRegistrationCostumePage"],
  ["read", "InviteList"],
  ["read", "Purchase"],
];
